"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sl: {
    "notFoundPage": {
      "message": "Izdelke ali strani ni bilo mogoče najti ali pa nimate dovoljenja za ogled."
    },
    "loginPage": {
      "title": "Prijava v Sprinx CRM",
      "username": "Uporabniško ime",
      "password": "Geslo",
      "loginButton": "Prijava"
    },
    "loginErrorPage": {
      "title": "Prijava ni bila uspešna",
      "error": "Prijava ni uspela. Uporabniškega imena ali gesla ni mogoče najti.",
      "pleaseRelogin": "Zdi se, da niste prijavljeni. Prosimo, poskušajte se prijaviti ponovno."
    },
    "oauthLogin": {
      "message": "Morate se prijaviti. Izberite enega od navedenih ponudnikov.",
      "loginButton": "Prijavite se s pomočjo računa Sprinx",
      "redirecting": "Čakanje na preusmeritev na avtentikacijski strežnik ..."
    },
    "logout": {
      "inProgress": "Odjava",
      "error": "Napaka pri odjavi",
      "gotoHome": "Preusmeritev na domačo stran",
      "success": "Odjava je bila uspešna."
    }
  }
};
var _default = messages;
exports.default = _default;